import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useLocation } from 'react-router-dom';
import { getProductOptions, getChannelOptions, submitBnaProgram } from "../../services/Api/Module/bnaProgram";
import liff from "@line/liff";

const BnaProgram = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedProduct, setSelectedProduct] = useState("");
    const [selectedChannel, setSelectedChannel] = useState("");
    const [productOptions, setProductOptions] = useState([]);
    const [channelOptions, setChannelOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [lineId, setLineId] = useState(null);

    // ดึงค่า bna จาก location state ที่ส่งมาจาก EventPolicy2
    const bnaParam = location.state?.bna || null;

    // Function สำหรับเรียก API Product Options
    const fetchProductOptions = async () => {
        try {
            setLoading(true);
            const response = await getProductOptions({});
            if (response.data.resultCode == 20000) {
                const productData = response.data.resultData || [];
                setProductOptions(productData);
            } else {
                console.error('Error fetching product options:', response?.data?.message);
            }
        } catch (error) {
            console.error('Error fetching product options:', error);
        } finally {
            setLoading(false);
        }
    };

    // Function สำหรับเรียก API Channel Options
    const fetchChannelOptions = async () => {
        try {
            setLoading(true);
            const response = await getChannelOptions({});
            if (response.data.resultCode == 20000) {
                const channelData = response.data.resultData || [];
                setChannelOptions(channelData);
            } else {
                console.error('Error fetching channel options:', response?.data?.message);
            }
        } catch (error) {
            console.error('Error fetching channel options:', error);
        } finally {
            setLoading(false);
        }
    };

    // เรียก API เมื่อ component mount
    useEffect(() => {
        getLineLiff();
        fetchProductOptions();
        fetchChannelOptions();
    }, []);

    // Set default selected values เมื่อได้ข้อมูลจาก API
    useEffect(() => {
        if (productOptions.length > 0 && !selectedProduct) {
            setSelectedProduct(productOptions[0].id);
        }
    }, [productOptions, selectedProduct]);

    useEffect(() => {
        if (channelOptions.length > 0 && !selectedChannel) {
            setSelectedChannel(channelOptions[0].id);
        }
    }, [channelOptions, selectedChannel]);

    // Function สำหรับหา URL รูปภาพของผลิตภัณฑ์ที่เลือก
    const getSelectedProductImage = () => {
        const selectedProductData = productOptions.find(product => product.id === +selectedProduct);
        return selectedProductData?.img
    };

    const getLineLiff = async () => {
        const _lineId = liff.getDecodedIDToken()?.sub
        setLineId(_lineId);
    }


    // Fallback options ในกรณีที่ API ไม่ทำงาน
    const defaultProductOptions = [
        { id: 1, value: "S-26 Gold Pro", name: "S-26 Gold Pro" },
        { id: 2, value: "S-26 Gold", name: "S-26 Gold" },
        { id: 3, value: "S-26 Gold Progress", name: "S-26 Gold Progress" }
    ];

    const defaultChannelOptions = [
        { id: 1, value: "Shopee", name: "Shopee" },
        { id: 2, value: "Lazada", name: "Lazada" },
        { id: 3, value: "7-Eleven", name: "7-Eleven" },
        { id: 4, value: "Tesco Lotus", name: "Tesco Lotus" },
        { id: 5, value: "Big C", name: "Big C" }
    ];

    const handleBack = () => {
        navigate(-1);
    };

    const handleNext = async () => {
        try {
            // ตรวจสอบว่ามี bna parameter หรือไม่
            if (!bnaParam) {
                alert('ไม่พบข้อมูล BNA กรุณาเข้าถึงหน้านี้ผ่านหน้า EventPolicy2');
                return;
            }

            setSubmitting(true);

            // เตรียมข้อมูลสำหรับส่งไป API
            const submitData = {
                lineUID: lineId,
                productSampling: selectedProduct,
                channelShopping: selectedChannel,
                bna: bnaParam
            };
            console.log(submitData)
            // เรียก API submitBnaProgram
            const response = await submitBnaProgram({ data: submitData });

            if (+response.data.resultCode === 20000) {
                // ไปหน้าถัดไปเมื่อส่งข้อมูลสำเร็จ
                navigate('/bna-program-success', {
                    state: {
                        resultData: response.data.resultData
                    }
                });
            } else {
                // อาจจะแสดง error message ให้ผู้ใช้
                alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง');
            }
        } catch (error) {
            alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <Helmet>
                <title>S-Mom</title>
                <meta name="title" content="S-Mom" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>
            <div id="pageBnaProgram">
                <main>
                    <div className="bna-program-logo">
                        <div className="bna-program-logo-image"></div>
                    </div>
                    <div>
                        <section id="pBnaProgram">
                            <div className="bContent">
                                <div className="productSection">
                                    <div className="sectionHeader">
                                        <img src="/assets/img/ui/form/ico-gift.svg" alt="Gift" className="sectionIcon" />
                                        <p>สินค้าตัวอย่างที่ได้รับ</p>
                                    </div>
                                    <div className="dropdownContainer">
                                        <select
                                            value={selectedProduct}
                                            onChange={(e) => setSelectedProduct(e.target.value)}
                                            className="productDropdown"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <option value="">กำลังโหลด...</option>
                                            ) : (
                                                (productOptions.length > 0 ? productOptions : defaultProductOptions).map((product) => (
                                                    <option key={product.id || product.name} value={product.id}>
                                                        {product.name}
                                                    </option>
                                                ))
                                            )}
                                        </select>
                                        <img src="/assets/img/ui/form/ico-arrow-select.svg" alt="Dropdown" className="dropdownArrow" />
                                    </div>
                                    <div className="productImage">
                                        <img
                                            src={getSelectedProductImage()}
                                            alt={selectedProduct || "S-26 Gold Pro"}
                                            onError={(e) => {
                                                e.target.src = "/assets/img/ci/register/s26-gold-pro-cartons.png";
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="channelSection">
                                    <div className="sectionHeader">
                                        <img src="/assets/img/ui/form/ico-cart.svg" alt="Cart" className="sectionIcon" />
                                        <p style={{marginTop:'6px'}}>ซื้อสินค้าช่องทางใดบ่อยที่สุด</p>
                                    </div>
                                    <div className="dropdownContainer">
                                        <select
                                            value={selectedChannel}
                                            onChange={(e) => setSelectedChannel(e.target.value)}
                                            className="channelDropdown"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <option value="">กำลังโหลด...</option>
                                            ) : (
                                                (channelOptions.length > 0 ? channelOptions : defaultChannelOptions).map((channel) => (
                                                    <option key={channel.id || channel.value} value={channel.id}>
                                                        {channel.name}
                                                    </option>
                                                ))
                                            )}
                                        </select>
                                        <img src="/assets/img/ui/form/ico-arrow-select.svg" alt="Dropdown" className="dropdownArrow" />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="confirm-button-container">
                        <button
                            className={`btn outline`}
                            onClick={handleBack}
                        >
                            ย้อนกลับ
                        </button>
                        <button
                            className={`btn`}
                            onClick={handleNext}
                            disabled={submitting || !selectedProduct || !selectedChannel}
                        >
                            {submitting ? 'กำลังบันทึก...' : 'ถัดไป'}
                        </button>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default BnaProgram;

